import { render, staticRenderFns } from "./reply.vue?vue&type=template&id=172005f4&"
import script from "./reply.vue?vue&type=script&lang=js&"
export * from "./reply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports